module.exports = __webpack_public_path__ + "img/intj-selected.08807a31.png";